import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { money } from 'utils/helpers';

const DailySalesReport = (data, periode, locationName) => {
    let y = 20
    const total = data.reduce((sum, row) => sum + (parseFloat(row.totalSales) || 0), 0);

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Transaction Report', 15, y);
    y = y + 8

    // Change to default font size and font wight
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');

    doc.text('Periode : ' + moment(periode).format("MMMM YYYY"), 15, y);
    y = y + 5

    doc.text('Lokasi : ' + locationName, 15, y);
    y = y + 5

    doc.text(`Total Penjualan : ${money(total)}`, 15, y);  
    y = y + 6

    const tableBody = data.map((row, index) => [
        moment(row.transactionDate).format('DD MMMM YYYY'),
        'Rp ' + money(row.totalSales)
    ]);

    autoTable(doc, {
        startY: y,
        head: [[
            'Tanggal', 
            'Jumlah'
        ]],
        body: tableBody,
        styles: {
            fontSize: 8,
            cellPadding: 1,
            lineWidth: 0.1,
        },
        headStyles: {
            fillColor: [215, 215, 215],
            textColor: 0,
            halign: 'center',
            valign: 'middle',
            lineWidth: 0.2,
            lineColor: 0
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            lineWidth: 0.2,
            lineColor: 0
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        margin: { top: 15, bottom: 10 },
        pageBreak: 'auto',
        didDrawPage: (data) => {
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;

            doc.setFontSize(8);
            doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 5);
        },
    });

    let yPos = doc.lastAutoTable.finalY + 10;
    const pageHeight = doc.internal.pageSize.height;

    if (yPos + 20 > pageHeight) {
        doc.addPage();
        yPos = 20;
    }

    // Open on new tab
    doc.output('dataurlnewwindow');
};

export default DailySalesReport